export const stateNameMap = {
  'Successful': 'Successful',
  'Faulted': 'Failed',
  'Stopped': 'Stopped',
  'Kører': 'Running',
  'Afventer': 'Waiting',
  'Suspenderet': 'Suspended',
  'Genoptaget': 'Resumed'
};

export const stateColorMap = {
  'Successful': '#22c55e',
  'Failed': '#ef4444',
  'Stopped': '#f59e0b',
  'Running': '#3b82f6',
  'Waiting': '#6b7280',
  'Suspended': '#f97316',
  'Resumed': '#06b6d4'
};